import { render, staticRenderFns } from "./TestpaperSort.vue?vue&type=template&id=1727245f&"
import script from "./TestpaperSort.vue?vue&type=script&lang=js&"
export * from "./TestpaperSort.vue?vue&type=script&lang=js&"
import style0 from "./TestpaperSort.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports